module.exports = __webpack_public_path__ + "assets/img/A5-5.c3696c2d.jpg";